(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The gift article data object on success, false otherwise.
   */
  const parseDataNode = function () {
    const dataNode = document.querySelector(
      '.vodl-gift-article script[type="application/json"]'
    );

    let parsedDataNode = {};

    try {
      parsedDataNode = JSON.parse(dataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedDataNode;
  };

  /**
   * Initializes the gift article functionality.
   */
  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[gift article]") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let giftArticleData = parseDataNode();
    if (!giftArticleData) {
      logger.log("gift article _init: No gift article data.");
      return;
    }

    const giftArticle = Vue.createApp({
      components: {
        GiftArticle: window["@russmedia-frontend/np-subscriptions"].GiftArticle,
        ValidateGiftToken:
          window["@russmedia-frontend/np-subscriptions"].ValidateGiftToken,
      },
      setup() {
        let evoSSOCookie = "";
        let sessionCookie = "";
        let showGiftArticle = Vue.ref(false);

        document.cookie.split(";").forEach((cookie) => {
          cookie = cookie.trim();

          if (cookie.startsWith("EvoSSO=")) {
            evoSSOCookie = cookie.substring("EvoSSO=".length);
          }
          if (cookie.startsWith("SsoSessionCookie=")) {
            sessionCookie = cookie.substring("SsoSessionCookie=".length);
          }
        });

        const post = giftArticleData.post || {};

        document.addEventListener("vodl_interaction_clicked", (event) => {
          if (event.detail.interaction.type === "gift") {
            showGiftArticle.value = true;
          }
        });

        function showContent() {
          window.dispatchEvent(
            new Event("vodl_close_paywall_and_show_content")
          );
        }

        function onModalClose() {
          showGiftArticle.value = false;
        }

        return {
          evoSSOCookie,
          sessionCookie,
          post,
          showGiftArticle,
          showContent,
          onModalClose,
        };
      },
      template: `<GiftArticle v-if="showGiftArticle" :sessionCookie="sessionCookie" :evoSSOCookie="evoSSOCookie" :post="post" @close="onModalClose" />
            <ValidateGiftToken :post="post" @show-content="showContent" />`,
    }).mount("#vodl-gift-article__wrapper");
  };

  init();
})(window, document);
